<header class="br-header mb-4" id="header" data-sticky="data-sticky">
   <div class="container-lg">
      <div class="header-top">
         <div class="header-logo">
            <a href="https://www.gov.br/pt-br">
               <img src="../../assets/images/govbr.png" alt="logo" />
            </a>
            <span class="br-divider vertical"></span>
            <div class="header-sign">&nbsp;&nbsp;Governo Federal</div>
         </div>
         <div class="header-actions">
            <div
               class="header-links dropdown"
               [ngClass]="{ show: isDropdownAcessoRapido }"
            >
               <button
                  class="br-button circle small"
                  type="button"
                  aria-label="Abrir Acesso Rápido"
                  data-toggle="dropdown"
                  [ngClass]="{ active: isDropdownAcessoRapido }"
                  (click)="toggleDropdown('acessoRapido', $event)"
               >
                  <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
               </button>
               <div class="br-list">
                  <div class="header">
                     <div class="title">Acesso Rápido</div>
                  </div>
                  <a
                     class="br-item"
                     href="https://www.gov.br/pt-br/orgaos-do-governo"
                     target="_blank"
                     rel="noopener"
                     >Órgãos do Governo
                  </a>
                  <a
                     class="br-item"
                     href="https://www.gov.br/acessoainformacao/pt-br"
                     target="_blank"
                     rel="noopener"
                     >Acesso à Informação
                  </a>
                  <a
                     class="br-item"
                     href="http://www4.planalto.gov.br/legislacao"
                     target="_blank"
                     rel="noopener"
                     >Legislação
                  </a>
                  <a
                     class="br-item"
                     href="https://www.gov.br/governodigital/pt-br/acessibilidade-digital"
                     target="_blank"
                     rel="noopener"
                     >Acessibilidade
                  </a>
               </div>
            </div>
            <span class="br-divider vertical mx-half mx-sm-1"></span>

            <div
               class="header-functions dropdown"
               [ngClass]="{ show: isDropdownFuncionalidades }"
            >
               <button
                  class="br-button circle small"
                  type="button"
                  aria-label="Abrir Funcionalidades do Sistema"
                  [ngClass]="{ active: isDropdownFuncionalidades }"
                  (click)="toggleDropdown('funcionalidades', $event)"
                  data-toggle="dropdown"
               >
                  <i class="fas fa-th" aria-hidden="true"></i>
               </button>

               <div class="br-list">
                  <div class="header">
                     <div class="title">Funcionalidades do Sistema</div>
                  </div>

                  <div class="br-item">
                     <a
                        class="br-button circle small"
                        href="https://www.vlibras.gov.br/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Acessibilidade"
                     >
                        <i
                           class="fas fa-assistive-listening-systems"
                           aria-hidden="true"
                        ></i>
                        <span class="text">Acessibilidade</span>
                     </a>
                  </div>

                  <div class="br-item">
                     <button
                        (click)="onAltoContraste()"
                        class="br-button circle small high-contrast-btn color-white link text-uppercase cursor-pointer"
                        type="button"
                        aria-label="Alto Contraste"
                     >
                        <i class="fas fa-adjust" aria-hidden="true"></i>
                        <span class="text">Alto Contraste</span>
                     </button>
                  </div>
               </div>
            </div>

            <div class="header-search-trigger">
               <button
                  class="br-button circle"
                  type="button"
                  aria-label="Abrir Busca"
                  data-toggle="search"
                  data-target=".header-search"
                  (click)="toggleSearch()"
               >
                  <i class="fas fa-search" aria-hidden="true"></i>
               </button>
            </div>
         </div>
      </div>

      <div class="header-bottom">
         <div class="header-menu">
            <div class="header-menu-trigger" id="header-navigation">
               <button
                  class="br-button small circle"
                  type="button"
                  aria-label="Menu"
                  data-toggle="menu"
                  data-target="#main-navigation"
                  id="navigation"
                  (click)="toggleMenu()"
               >
                  <i class="fas fa-bars"></i>
               </button>
            </div>
            <div class="header-info">
               <div class="header-title">
                  <a routerLink="/">CNCST</a>
               </div>
               <div class="header-subtitle">
                  <a routerLink="/"
                     >Catálogo Nacional de Cursos Superiores de Tecnologia</a
                  >
               </div>
            </div>
         </div>

         <form [formGroup]="formularioBarraPesquisa" (ngSubmit)="onPesquisar()">
            <div
               class="header-search"
               [ngClass]="{ active: isSearch }"
               id="main-searchbox"
            >
               <div class="br-input has-icon">
                  <label for="searchbox">Texto da pesquisa</label>
                  <input
                     type="text"
                     placeholder="O que você procura?"
                     id="catalogo-search"
                     formControlName="stringBusca"
                  />
                  <button
                     class="br-button circle small"
                     type="submit"
                     aria-label="Pesquisar"
                  >
                     <i class="fas fa-search" aria-hidden="true"></i>
                  </button>
               </div>
               <button
                  class="br-button circle search-close ml-1"
                  type="button"
                  aria-label="Fechar Busca"
                  data-dismiss="search"
                  (click)="toggleSearch()"
               >
                  <i class="fas fa-times" aria-hidden="true"></i>
               </button>
            </div>
         </form>
      </div>
   </div>
</header>
